import React, { useEffect, useState } from "react";

const ScrollProgress = () => {
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.body.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScroll(progress);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        right: 0,
        top: 0,
        width: "6px",
        height: "100%",
        background: "#ddd",
      }}
    >
      <div
        style={{
          width: "100%",
          height: `${scroll}%`,
          background: "White",
          transition: "height 0.1s linear",
        }}
      />
    </div>
  );
};

export default ScrollProgress;
